export default [
  {
    path: "/friends",
    meta: { navbarTitle: "Freunde", fullWidth: true, backgroundColor: "#212121" },
    name: "Friends",

    component: () => import(/* webpackChunkName: "friends" */ "@/views/friends/Friends.vue"),
  },
]
